<template>
    <div class="sakura-box">
        <div class="loading" v-show="loading">
          <van-loading class="loading-icon" color="#E33D72" vertical>加载中...</van-loading>
       </div>
        <div class="to-top" @click="toTop">顶部</div>
        <div class="nav-bar">
            <img class="nav-return" @click="toBack" src="@/assets/sakuraBox/icon-black-return.png" alt="">
            <img class="nav-share" v-if="isApp" @click="navShareClick" src="@/assets/sakuraBox/icon-black-share.png" alt="">
            我的存档
        </div>
        <div class="block-record-list">
            <div class="block-name">
                <img src="@/assets/sakuraBox/title-block-myRecord.png" alt="">
            </div>
            <div class="type-list">
                <div @click="tagActive = -1" :class="tagActive === -1 ? 'tag-type-active' : ''" class="tag-type"><div class="tag-type-inside">全部</div></div>
                <div @click="tagActive = 1" :class="tagActive === 1 ? 'tag-type-active' : ''" class="tag-type"><div class="tag-type-inside">审核通过</div></div>
                <div @click="tagActive = 0" :class="tagActive === 0 ? 'tag-type-active' : ''" class="tag-type"><div class="tag-type-inside">审核中</div></div>
                <div @click="tagActive = 2" :class="tagActive === 2 ? 'tag-type-active' : ''" class="tag-type"><div class="tag-type-inside">未通过</div></div>
            </div>
            <CardList v-show="!loading" @openPanel="openPanel" @refreshList="refreshList"  :cardType="2" :dataList="dataList"></CardList>
            <div v-if="!noMore && dataList.length !== 0 && !loading" class="btn-loading-more active" @click="loadMore">
                <span>展开更多</span>
            </div>
            <div class="no-more" v-if="noMore && dataList.length !== 0 && !loading">
                到底啦~
            </div>
        </div>
        <Model @openPanel="openPanel" :modelType='modelType' :shareArcId="shareArcId" @closePanel="closePanel"></Model>
    </div>
</template>

<script>
import CardList from './components/CardList.vue';
import active from '@/utils/axios/index';
import {mapState} from 'vuex';
import Model from './components/Model.vue';
import primaryApi from '@/utils/primaryApi';
import config from '@/../config';
export default {
  components: {
    CardList,
    Model,
  },
  /**
 * vue内置data函数
 * @return {Object} 需要双向绑定的的变量列表
 */
  data() {
    return {
      page: 1,
      dataList: [],
      tagActive: -1,
      noMore: false,
      modelType: false,
      loading: false,
      shareArcId: '',
      isApp: false,
    };
  },
  computed: {
    ...mapState([
      'uuid',
    ]),
  },
  watch: {
    /**
    * vue内置data函数
    * @return {void}
    */
    tagActive() {
      this.page = 1,
      this.noMore = false;
      this.sukuraBoxMyArc();
    },
  },
  /**
    * vue内置mounted生命周期函数
    * @return {void}
  */
  mounted() {
    // 是否app内部打开
    if (primaryApi.isSource === 'pd') {
    // 隐藏原生顶栏
      primaryApi.setNativeTitleShow(false);
      this.isApp = true;
    }
    this.sukuraBoxMyArc();
  },
  methods: {
    /**
    * 点击分享按钮
    * @return {void}
    */
    navShareClick() {
    // 分享按钮的点击
      this.$tea('event_sakura_box_share_click', {source: primaryApi.isSource === 'pd' ? 'app' : 'web'});
      this.modelType = 1;
    },
    /**
    * 关闭弹窗
    * @return {void}
    */
    closePanel() {
      this.modelType = false;
    },
    /**
    * 打开弹窗
    * @return {void}
    * @param {number} type 弹框类型
    * @param {string} id 存档id
    */
    openPanel(type, id) {
      this.modelType = type;
      this.shareArcId = id;
    },
    /**
    * 加载更多
    * @return {void}
    */
    loadMore() {
      this.page++;
      this.sukuraBoxMyArc();
    },
    /**
    * 返回页面顶部
    * @return {void}
    */
    toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    /**
    * 返回上一页
    * @return {void}
    */
    toBack() {
      this.$router.go(-1);
    },
    /**
    * 用户操作 点赞 收藏 分享
    * @return {void}
    */
    sukuraBoxMyArc() {
      this.loading = true;
      active.sukuraBoxMyArc(config.SAKURA_BASE_URL + '/api/sakura/myArc', {
        status: this.tagActive === -1 ? '' : this.tagActive,
        uid: this.uuid,
        page: this.page,
        pageSize: 5,
      }).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 100);
        if (res.return_code === 200 || res.code === 200) {
          this.dataList = this.page === 1 ? res.data : [...this.dataList, ...res.data];
          if (res.data.length < 5) {
            this.noMore = true;
          }
        } else {
          this.$toast(res.return_msg || res.message || res.msg);
        }
      });
    },
    /**
    * 刷新存档列表
    * @return {void}
    * @param {string} arcId 存档ID
    */
    refreshList(arcId) {
      this.dataList = this.dataList.filter((item) => item.id !== arcId);
      if (this.dataList === 0) {
        this.page = 1;
        this.sukuraBoxMyArc();
      }
    },
    /**
    * 判读是否app内部打开
    * @return {void}
    */
    correctTerminal() {
      if (primaryApi.isSource === 'pd') {
        return true;
      } else {
        this.modelType = 2;
      }
    },
  },
};
</script>

<style scoped>
    .to-top{
        width: 60px;
        height: 30px;
        opacity: 0.3;
        position: fixed;
        right: 0;
        bottom: 30px;
        border-radius: 15px 0 0 15px;
        color: white;
        line-height: 30px;
        padding-left: 28px;
        background-image: url('~assets/sakuraBox/to-top.png');
        background-repeat: no-repeat;
        background-size: 14px 11px;
        background-position: left 10px center;
        background-color: #000000;
        font-size: 12px;
        z-index: 5;
    }
    .sakura-box{
        min-height: 100vh;
        padding-top: 69px;
        width: 100%;
        background: #FFF6FB;
        padding-bottom: 16px;
    }
    .nav-bar{
        width: 100%;
        height: 69px;
        padding-top: 16px;
        line-height: 49px;
        text-align: center;
        font-size: 17px;
        background: white;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;
    }
    .nav-return{
        width: 11px;
        height: 19px;
        position: absolute;
        left: 17px;
        top: 34px;
    }
    .nav-share{
        width: 19px;
        height: 19px;
        position: absolute;
        right: 19px;
        top: 34px;
    }
    .icon-link{
        width: 251px;
        height: 19px;
        position: absolute;
        left: 50%;
        top: -3px;
        transform: translate(-50%,-50%);
        z-index: 2;
    }
    .block-record-list{
        background: #FFF6FB;
        padding-top: 17px;
    }
    .block-name{
        width: 281px;
        height: 24px;
        margin: 0 auto 14px auto;
        background: url('~assets/sakuraBox/title-bg-large.png') no-repeat;
        background-size: 100% 18px;
        background-position: center bottom;
        position: relative;
    }
    .block-name img{
        width: 155px;
        height: 24px;
        margin: 0 auto;
        display: block;
    }
    .active:active{
        transform: scale(0.9);
    }
    .btn-loading-more{
        width: 326px;
        background: white;
        height: 36px;
        line-height: 34px;
        border:solid 1px #FA7CB5;
        border-radius: 10px;
        margin: 0 auto;
        text-align: center;
    }
    .btn-loading-more span{
        display: inline-block;
        margin: 0 auto;
        padding-right: 18px;
        background: url('~assets/sakuraBox/icon-add.png') no-repeat;
        background-size: 0.11rem;
        background-position: right center;
        font-size: 12px;
        color: #555;
    }
    .type-list{
        width: 324px;
        margin: 0 auto;
    }
    .tag-type{
        width: 73px;
        height: 32px;
        margin: 4px;
        background: #FFEBEE;
        text-align: center;
        line-height: 24px;
        border-radius: 6px;
        display: inline-block;
        color: #696969;
        font-size: 12px;
        padding: 3px;
    }
    .tag-type:active{
      transform: scale(0.9);
    }
    .tag-type-inside{
        border-radius: 5px;
        border: solid 1px #FBD3DD;
    }
    .tag-type-active{
        background: #FA7CB5;
        color: white;
    }
    .no-more{
        color: #F967A4;
        text-align: center;
        font-size: 12px;
        margin-bottom: 20px;
    }
    .loading{
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.7);
        position: fixed;
        z-index: 10;
        left: 0;
        top: 0;
    }
    .loading-icon{
        top: 50%;
        left: 50%;
        position: absolute;
        transform: translate(-50%,-50%);
    }
</style>
